/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Sync_FailedInputs */



/**
* | output |
* | --- |
* | "Project sync failed: {message}" |
*
* @param {Team_Sync_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_failed = /** @type {((inputs: Team_Sync_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la synchronisation du projet : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projektsynchronisierung fehlgeschlagen: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sincronizzazione del progetto non riuscita: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Синхронизация проекта не удалась: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error de sincronización del proyecto: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目同步失败：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトの同期に失敗しました: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट सिंक विफल: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na sincronização do projeto: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Project sync failed: ${i?.message}`)
});